export default function LoadingSpinner({ message = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-3">
      <div className="w-8 h-8 rounded-full border-2 border-brand-violet dark:border-brand-violet-on-dark border-t-transparent animate-spin" />
      <p className="text-gray-400 text-sm">{message}</p>
    </div>
  );
}
